import type { TestFunction } from 'yup/lib/util/createValidation'

// 18 years: 568025136000

const dateOlderThanTest =
  (offset: number): TestFunction<Date> =>
  (date, { createError }) => {
    return Date.now() - offset >= date.getTime() ?? createError()
  }

export default dateOlderThanTest
